import React from "react";
import LeadsTableBody from "./LeadsTableBody";

/**
 * Wrapper for rendering Customers rows.
 */
function CustomersTable(props) {
  return <LeadsTableBody {...props} activeTab="Tenants" />;
}

export default CustomersTable;

